import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BaseButtonStyle = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 600,
    textTransform: 'none',
    padding: '10px 24px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        boxShadow: '0 6px 8px rgba(0, 0, 0, 0.15)',
    },
    marginLeft: '3em',

    // Mobile optimization
    [theme.breakpoints.down('sm')]: {
        // width: '90%', // Full width on mobile
        // marginTop: '3em',
        // marginLeft: '3em',
        // marginRight: '3em',
    },
}));